// extracted by mini-css-extract-plugin
export default {"pageContainer":"FzlL","buttonsContainer":"rAPj"};